import { useDispatch, useSelector } from "react-redux"
import { toggleRoomDetailsDrawer } from "src/store/navigation/navigationSlice"
import { selectBloqueadaSection } from "src/store/roomDetails/bloqueadaSlice"
import { selectCleaningSection } from "src/store/roomDetails/cleaningSlice"
import { selectMaintenanceSection } from "src/store/roomDetails/maintenance.Slice"
import { selectPendienteSupervisionSection } from "src/store/roomDetails/pendienteSupervisionSlice"
import { selectRoom } from "src/store/rooms/roomsSlice"
import { RootState } from "src/store/store"

// Duración de la transición de salida de .drawer__content (Drawer.css)
const DRAWER_CLOSE_ANIMATION_MS = 500

export function useRoomDarwer() {
    const { isRoomDetailsDrawerOpen } = useSelector((state: RootState) => state.navigation)
    const dispatch = useDispatch()

    return {
        visible: isRoomDetailsDrawerOpen,
        onClose: () => {
            dispatch(toggleRoomDetailsDrawer(false))
            // Se limpia hasta que termina la animación de salida del drawer: limpiar la habitación de inmediato cambia
            // el drawer del estado por otro y desaparece sin deslizarse. Si mientras tanto se volvió a abrir, no se toca
            setTimeout(() => {
                dispatch(((dispatchLater: any, getState: () => RootState) => {
                    if (getState().navigation.isRoomDetailsDrawerOpen) {
                        return
                    }
                    dispatchLater(selectPendienteSupervisionSection("home"))
                    dispatchLater(selectBloqueadaSection("home"))
                    dispatchLater(selectCleaningSection("home"))
                    dispatchLater(selectMaintenanceSection("home"))
                    dispatchLater(selectRoom({}))
                }) as any)
            }, DRAWER_CLOSE_ANIMATION_MS)
        },
        onOpen: () => dispatch(toggleRoomDetailsDrawer(true)),
    }
}
